import { Box, Flex, Heading, IconButton, Image, Text } from "@highoutput/ui-components";
import { useState } from "react";
import { InView } from "react-intersection-observer";
import Rating from "../rating";
import { SmallArrowLeft, SmallArrowRight } from "./icon";

export const mock = [
  {
    name: "Kent Bryan Clarabal Maglinao",
    position: "Backend Developer",
    testimonial:
      "Coaching has been a truly transformative experience. I have been able to build consistent habits that have had a positive impact on my efficiency both in the workplace and in my personal life. Additionally, the goal-setting strategies that were taught throughout the program have provided me with greater clarity and direction when it comes to my future aspirations. Overall, I am incredibly grateful for the opportunity to participate in the Advante coaching and the benefits it has provided me.",
    image: "images/campaign/kent-image.webp",
  },
  {
    name: "Jade Kenneth Darunday",
    position: "Frontend Developer",
    testimonial:
      "I found having a performance coach to be a great help in both my career and personal development. Through the coaching sessions, I was able to improve in key areas such as stress management, goal setting, time management, and overall well-being. The benefits have been significant, and I feel more empowered than ever to take on new challenges. I am grateful that our company has implemented this program for its employees, and for the opportunity it provides us.",
    image: "images/campaign/jade-image.webp",
  },

  {
    name: "Leo Jr. Malaya",
    position: "Backend Developer",
    testimonial:
      "Thanks to Advante, I now feel more confident when it comes to learning new and complex technologies. Before participating in the coaching program, I often felt overwhelmed by the sheer amount of information I needed to keep up with. However, Advante provided me with the support and guidance I needed to navigate these challenges with ease. Now, I'm excited to take on new projects and technologies, knowing that I have the skills and knowledge to succeed.",
    image: "images/campaign/leo-image.webp",
  },
  {
    name: "Jane Dhell S. Cagas",
    position: "Junior UI Designer",
    testimonial:
      "Coaching has been a tremendously beneficial experience in both my professional and personal life. I learned how to set priorities more effectively. Furthermore, the program has assisted me in maintaining a positive mindset by focusing on opportunities rather than obstacles.",
    image: "images/campaign/jadey-image.webp",
  },
  {
    name: "Hannah Deloy",
    position: "Senior Marketing Executive",
    testimonial:
      "Advante coaching has improved my goal-setting abilities, allowing me to set more achievable goals with greater clarity and focus.",
    image: "images/campaign/hannah-image.webp",
  },
];

const CampaignContent = () => {
  const [step, setStep] = useState(0);
  return (
    <Box>
      <InView triggerOnce delay={200}>
        {({ ref, inView }) => (
          <Flex
            ref={ref}
            direction={{
              base: "column",
              lg: "row",
            }}
            alignItems="center"
            bg="rgba(240,237,236,0.2)"
            pt={{ base: "3rem", lg: "6rem" }}
            pb={{ base: "3rem", lg: "6rem" }}
            mx={{ base: "1rem", lg: "1.5rem", xl: "auto" }}
            justifyContent="center"
            overflow="hidden"
            sx={{
              opacity: 0,
              transform: "translateY(10vh)",
              transition: "transform 600ms ease-out, opacity 600ms ease-out",
              willChange: "transform, opacity",
              ...(inView && {
                opacity: 1,
                transform: "none",
              }),
            }}
            gap={{ base: 12, lg: 16, xl: 20 }}
            bgColor="white"
          >
            {mock.length && (
              <>
                <Box
                  w={{ lg: "50%", xl: 578 }}
                  fontFamily="'Inter', sans-serif"
                  ml={{ lg: 0, xl: "3.5rem" }}
                >
                  <Rating
                    value={5}
                    readonly
                    config={{
                      icon: {
                        size: {
                          width: "20px",
                          height: "20px",
                        },
                      },
                    }}
                    data-testid={`rating`}
                  />

                  <Heading
                    variant={"24/28"}
                    color="#0D3050"
                    mt={{ base: "1.5rem", lg: "2rem" }}
                    mb={{ base: "2rem", lg: "3rem" }}
                    fontWeight={400}
                    letterSpacing={{ base: "-0.02em", lg: "0.3px" }}
                  >
                    {mock[step].testimonial}
                  </Heading>

                  <Flex
                    justifyContent="space-between"
                    direction={{
                      base: "column",
                      lg: "row",
                    }}
                  >
                    <Box>
                      <Text variant="18/18" fontWeight={500} color="rgba(13,48,80,0.8)">
                        {mock[step].name}
                      </Text>
                      <Text variant="16/24" letterSpacing="0.02em" color="rgba(13,48,80,0.6)">
                        {mock[step].position}
                      </Text>
                    </Box>
                    <Flex gap={{ base: 4, lg: 8 }} mt={{ base: "24px", lg: 0 }}>
                      <IconButton
                        icon={
                          <SmallArrowLeft
                            width={14}
                            height={14}
                            stroke={step !== 0 ? "rgb(13,48,80)" : "rgba(240,237,236,0.4)"}
                          />
                        }
                        aria-label="right"
                        bgColor="white"
                        variant="outline"
                        colorScheme="gray"
                        border={
                          step !== 0
                            ? "1px solid rgb(240,237,236,0.6)"
                            : "1px solid rgba(240,237,236,0.4)"
                        }
                        borderTopRadius="50%"
                        borderBottomRadius="50%"
                        paddingBlock={7}
                        paddingInline={5}
                        cursor={step !== 0 ? "pointer" : "no-drop"}
                        onClick={() => {
                          if (step !== 0) {
                            setStep(step - 1);
                          }
                        }}
                        _hover={{
                          bgColor: step !== 0 ? "rgba(240,237,236,0.2)" : "white",
                        }}
                        disabled={step === 0 && false}
                      />

                      <IconButton
                        icon={
                          <SmallArrowRight
                            width={14}
                            height={14}
                            stroke={step !== 4 ? "rgb(13,48,80)" : "#D6D6D6"}
                          />
                        }
                        aria-label="right"
                        bgColor="white"
                        variant="outline"
                        colorScheme="gray"
                        borderTopRadius="50%"
                        border={
                          step !== 4
                            ? "1px solid rgb(240,237,236,0.6)"
                            : "1px solid rgba(240,237,236,0.4)"
                        }
                        borderBottomRadius="50%"
                        paddingBlock={7}
                        paddingInline={5}
                        cursor={step !== 4 ? "pointer" : "no-drop"}
                        onClick={() => {
                          if (step !== 4) {
                            setStep(step + 1);
                          }
                        }}
                        _hover={{
                          bgColor: step !== 4 ? "rgba(240,237,236,0.2)" : "white",
                        }}
                        disabled={step === 4 && false}
                      />
                    </Flex>
                  </Flex>
                </Box>

                <Box w={{ lg: "50%", xl: 592 }} h={{ base: 560, lg: 516, xl: 592 }}>
                  <Image
                    ref={ref}
                    src={mock[step].image}
                    alt={mock[step].name}
                    loading="lazy"
                    objectFit="cover"
                    w={{ base: 343, lg: 456, xl: "100%" }}
                    h={{ base: 560, lg: 516, xl: 592 }}
                  />
                </Box>
              </>
            )}
          </Flex>
        )}
      </InView>
    </Box>
  );
};

export default CampaignContent;
